import React from "react";

interface Props {
  color?: string;
  size?: number;
}
const LongTextInputIcon: React.FC<Props> = ({ color = "#79808A", size = 20 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3385 11.4106L18.3394 11.4115C18.351 11.4231 18.3603 11.4369 18.3666 11.4521C18.3729 11.4673 18.3761 11.4836 18.3761 11.5C18.3761 11.5164 18.3729 11.5327 18.3666 11.5479C18.3603 11.5631 18.351 11.5769 18.3394 11.5885L18.3389 11.5889L14.5889 15.3389C14.5654 15.3625 14.5334 15.3758 14.5 15.3758C14.4666 15.3758 14.4346 15.3625 14.4111 15.3389C14.3875 15.3154 14.3742 15.2834 14.3742 15.25C14.3742 15.2166 14.3875 15.1846 14.4111 15.1611L18.1611 11.4111L18.1615 11.4106C18.1731 11.399 18.1869 11.3897 18.2021 11.3834C18.2173 11.3771 18.2336 11.3739 18.25 11.3739C18.2664 11.3739 18.2827 11.3771 18.2979 11.3834C18.3131 11.3897 18.3269 11.399 18.3385 11.4106ZM3.44562 17.5544L3.78503 17.215L3.44562 17.5544C3.89102 17.9998 4.49511 18.25 5.125 18.25H18.875C19.5049 18.25 20.109 17.9998 20.5544 17.5544C20.9998 17.109 21.25 16.5049 21.25 15.875V7.125C21.25 6.49511 20.9998 5.89102 20.5544 5.44562C20.109 5.00022 19.5049 4.75 18.875 4.75H5.125C4.49511 4.75 3.89102 5.00022 3.44562 5.44562C3.00022 5.89102 2.75 6.49511 2.75 7.125V15.875C2.75 16.5049 3.00022 17.109 3.44562 17.5544ZM18.6925 11.0575C18.7507 11.1156 18.7969 11.1845 18.8284 11.2605C18.8599 11.3364 18.8761 11.4178 18.8761 11.5C18.8761 11.5822 18.8599 11.6636 18.8284 11.7395C18.7969 11.8155 18.7507 11.8844 18.6925 11.9425L14.9425 15.6925C14.8251 15.8099 14.666 15.8758 14.5 15.8758C14.334 15.8758 14.1749 15.8099 14.0575 15.6925C13.9401 15.5751 13.8742 15.416 13.8742 15.25C13.8742 15.084 13.9401 14.9249 14.0575 14.8075L17.8075 11.0575C17.8656 10.9993 17.9345 10.9531 18.0105 10.9216C18.0864 10.8901 18.1678 10.8739 18.25 10.8739C18.3322 10.8739 18.4136 10.8901 18.4895 10.9216C18.5655 10.9531 18.6344 10.9993 18.6925 11.0575ZM18.1611 14.5361L18.1615 14.5356C18.1731 14.524 18.1869 14.5147 18.2021 14.5084C18.2173 14.5021 18.2336 14.4989 18.25 14.4989C18.2664 14.4989 18.2827 14.5021 18.2979 14.5084L18.4895 14.0466L18.2979 14.5084C18.3131 14.5147 18.3269 14.524 18.3385 14.5356L18.3394 14.5365C18.351 14.5481 18.3603 14.5619 18.3666 14.5771C18.3729 14.5923 18.3761 14.6086 18.3761 14.625C18.3761 14.6414 18.3729 14.6577 18.3666 14.6729C18.3603 14.6881 18.351 14.7019 18.3394 14.7135L18.3389 14.7139L17.7139 15.3389C17.6904 15.3625 17.6584 15.3758 17.625 15.3758C17.5916 15.3758 17.5596 15.3625 17.5361 15.3389C17.5125 15.3154 17.4992 15.2834 17.4992 15.25C17.4992 15.2166 17.5125 15.1846 17.5361 15.1611L18.1611 14.5361ZM2.5 7.125C2.5 6.42881 2.77656 5.76113 3.26884 5.26884C3.76113 4.77656 4.42881 4.5 5.125 4.5H18.875C19.5712 4.5 20.2389 4.77656 20.7312 5.26884C21.2234 5.76113 21.5 6.42881 21.5 7.125V15.875C21.5 16.5712 21.2234 17.2389 20.7312 17.7312C20.2389 18.2234 19.5712 18.5 18.875 18.5H5.125C4.42881 18.5 3.76113 18.2234 3.26884 17.7312C2.77656 17.2389 2.5 16.5712 2.5 15.875V7.125Z"
        fill={color}
        stroke={color}
      />
      <rect
        x="9.5"
        y="8.25"
        width="1.25"
        height="7.5"
        rx="0.625"
        fill={color}
      />
      <rect
        x="5.75"
        y="9.5"
        width="1.25"
        height="8.75"
        rx="0.625"
        transform="rotate(-90 5.75 9.5)"
        fill={color}
      />
    </svg>
  );
};

export default LongTextInputIcon;
